(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      
      // 高度なUI状態管理
      this.scrollVelocity = 0;
      this.lastScrollTime = Date.now();
      this.rafId = null;
      this.headerHeight = 0;
      this.isScrollingDown = false;
      this.scrollThreshold = 5; // スクロール感度
      this.velocityThreshold = 0.5; // 速度閾値
      
      // パフォーマンス最適化
      this.throttleDelay = 8; // 120fps相当
      this.lastThrottleTime = 0;
      
      // アニメーション状態
      this.animationState = 'idle'; // idle, revealing, hiding, resetting
      this.hasScrolled = false;
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      // モバイルメニュー関連 - 修正版
      this.menuDrawer = document.getElementById('Details-menu-drawer-container');
      this.isMenuOpen = false;

      // 初期ヘッダー高さを取得
      this.headerHeight = this.header.offsetHeight;
      
      // プレミアムUI初期化
      this.initializePremiumFeatures();
      
      this.onScrollHandler = this.optimizedScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, { passive: true });
      window.addEventListener('resize', this.handleResize.bind(this), { passive: true });

      // メニューの開閉状態を監視
      this.setupMenuObserver();

      this.createObserver();
      
      // 初期状態のセットアップ
      this.setupInitialState();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      window.removeEventListener('resize', this.handleResize);
      
      if (this.rafId) {
        cancelAnimationFrame(this.rafId);
      }
    }

    initializePremiumFeatures() {
      // CSS変数でアニメーション制御
      this.header.style.setProperty('--header-transition', 'transform 0.3s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.3s ease, backdrop-filter 0.3s ease');
      
      // プレミアムスタイルを動的に追加
      if (!document.getElementById('premium-header-styles')) {
        const style = document.createElement('style');
        style.id = 'premium-header-styles';
        style.textContent = `
          .header-premium {
            transition: var(--header-transition);
            will-change: transform, opacity, backdrop-filter;
            backface-visibility: hidden;
            transform: translateZ(0);
          }
          
          .header-premium--scrolled {
            backdrop-filter: blur(20px) saturate(180%);
            background: rgba(255, 255, 255, 0.85);
            border-bottom: 1px solid rgba(0, 0, 0, 0.1);
            box-shadow: 0 1px 20px rgba(0, 0, 0, 0.05);
          }
          
          /* メニューが開いている時はヘッダーエフェクトを無効化 */
          .header-premium--menu-open {
            transform: none !important;
            backdrop-filter: none !important;
            z-index: 100 !important;
            will-change: auto !important;
            contain: none !important;
          }
          
          /* メニュードロワーのz-index修正 - さらに高く設定 */
          .menu-drawer-container {
            z-index: 99999 !important;
            position: relative !important;
          }
          
          .menu-drawer {
            z-index: 99999 !important;
            position: absolute !important;
          }
          
          .menu-drawer-container[open] {
            z-index: 99999 !important;
          }
          
          /* メニューが開いている時の追加修正 */
          details[open] .menu-drawer {
            z-index: 99999 !important;
            position: absolute !important;
            transform: translateX(0) !important;
            visibility: visible !important;
          }
          
          /* メニューの親要素のtransform影響を無効化 */
          .header-premium--menu-open .menu-drawer-container,
          .header-premium--menu-open header-drawer {
            transform: none !important;
            will-change: auto !important;
            contain: none !important;
          }
          
          /* 確実にメニューを表示させる */
          .header-premium--menu-open details[open] .menu-drawer {
            left: 0 !important;
            top: 100% !important;
            transform: translateX(0) !important;
            visibility: visible !important;
            opacity: 1 !important;
          }
          
          .header-premium--revealing {
            transform: translateY(0);
            opacity: 1;
            animation: headerSlideDown 0.3s cubic-bezier(0.4, 0, 0.2, 1);
          }
          
          .header-premium--velocity-fast {
            transition-duration: 0.2s;
          }
          
          .header-premium--velocity-slow {
            transition-duration: 0.4s;
          }
          
          @keyframes headerSlideDown {
            from {
              transform: translateY(-100%);
              opacity: 0;
            }
            to {
              transform: translateY(0);
              opacity: 1;
            }
          }
          
          @keyframes headerPulse {
            0%, 100% { transform: scale(1); }
            50% { transform: scale(1.02); }
          }
          
          .header-premium--interactive {
            animation: headerPulse 2s ease-in-out infinite;
          }
          
          /* スムーズなホバー効果 */
          .header-premium .header__menu-item,
          .header-premium .header__icon {
            transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
          }
          
          .header-premium .header__menu-item:hover {
            transform: translateY(-1px);
            color: var(--accent-color, #000);
          }
          
          .header-premium .header__icon:hover {
            transform: scale(1.1);
            filter: brightness(1.1);
          }
          
          /* ローディング時のシマー効果 */
          @keyframes shimmer {
            0% { background-position: -200px 0; }
            100% { background-position: calc(200px + 100%) 0; }
          }
          
          .header-premium--loading {
            background: linear-gradient(90deg, transparent, rgba(255,255,255,0.4), transparent);
            background-size: 200px 100%;
            animation: shimmer 1.5s infinite;
          }
        `;
        document.head.appendChild(style);
      }
      
      // プレミアムクラスを追加
      this.header.classList.add('header-premium');
    }

    setupMenuObserver() {
      if (this.menuDrawer) {
        // MutationObserverでメニューの開閉状態を監視
        const observer = new MutationObserver((mutations) => {
          mutations.forEach((mutation) => {
            if (mutation.type === 'attributes' && mutation.attributeName === 'open') {
              const isOpen = this.menuDrawer.hasAttribute('open');
              this.handleMenuToggle(isOpen);
            }
          });
        });
        
        observer.observe(this.menuDrawer, {
          attributes: true,
          attributeFilter: ['open']
        });
        
        // 初期状態をチェック
        this.isMenuOpen = this.menuDrawer.hasAttribute('open');
        if (this.isMenuOpen) {
          this.handleMenuToggle(true);
        }
      }
    }

    handleMenuToggle(isOpen) {
      this.isMenuOpen = isOpen;
      
      if (isOpen) {
        // メニューが開いた時 - より強力な無効化
        this.header.classList.add('header-premium--menu-open');
        
        // ヘッダーのアニメーション処理を一時停止
        if (this.rafId) {
          cancelAnimationFrame(this.rafId);
        }
        
        // ヘッダーのtransform関連プロパティを一時的に無効化
        this.header.style.transform = 'none';
        this.header.style.willChange = 'auto';
        this.header.style.contain = 'none';
        
        // メニューを確実に表示
        setTimeout(() => {
          const menuDrawer = document.querySelector('.menu-drawer');
          if (menuDrawer) {
            menuDrawer.style.transform = 'translateX(0)';
            menuDrawer.style.visibility = 'visible';
            menuDrawer.style.zIndex = '99999';
          }
        }, 50);
        
      } else {
        // メニューが閉じた時
        this.header.classList.remove('header-premium--menu-open');
        
        // ヘッダーのプロパティを元に戻す
        this.header.style.transform = '';
        this.header.style.willChange = 'transform, opacity';
        // PCメニューが開いていなければcontainを元に戻す
        if (!this.isPCMenuOpen) {
          this.header.style.contain = 'layout style paint';
        }
      }
    }

    handleResize() {
      // レスポンシブ対応
      this.headerHeight = this.header.offsetHeight;
      this.createObserver();
    }

    createObserver() {
      if (this.observer) {
        this.observer.disconnect();
      }
      
      this.observer = new IntersectionObserver((entries) => {
        this.headerBounds = entries[0].intersectionRect;
      }, {
        threshold: [0, 0.25, 0.5, 0.75, 1],
        rootMargin: '0px 0px -10px 0px'
      });

      this.observer.observe(this.header);
    }

    calculateScrollVelocity(scrollTop) {
      const now = Date.now();
      const timeDelta = now - this.lastScrollTime;
      const scrollDelta = scrollTop - this.currentScrollTop;
      
      if (timeDelta > 0) {
        this.scrollVelocity = Math.abs(scrollDelta) / timeDelta;
      }
      
      this.lastScrollTime = now;
      this.isScrollingDown = scrollDelta > 0;
    }

    setupInitialState() {
      // 初期状態でのパフォーマンス最適化
      // containを安全な値に変更（メガメニュー表示のため）
      this.header.style.contain = 'style';
      this.header.style.willChange = 'transform, opacity';
    }

    optimizedScroll() {
      // メニューが開いている時はスクロール処理をスキップ
      if (this.isMenuOpen) {
        return;
      }
      
      const now = Date.now();
      
      // スロットリング（120fps）
      if (now - this.lastThrottleTime < this.throttleDelay) {
        return;
      }
      this.lastThrottleTime = now;
      
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      
      // 速度計算
      this.calculateScrollVelocity(scrollTop);
      
      // 予測検索が開いている場合は処理しない
      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
      
      // メインスクロール処理
      this.handleScrollLogic(scrollTop);
      
      this.currentScrollTop = scrollTop;
    }

    handleScrollLogic(scrollTop) {
      const scrollProgress = Math.min(scrollTop / 200, 1); // 200pxでフル効果
      
      // スクロール状態に応じたUI更新
      if (scrollTop > this.scrollThreshold) {
        if (!this.hasScrolled) {
          this.hasScrolled = true;
          this.header.classList.add('header-premium--scrolled');
        }
        
        // 速度に応じたアニメーション調整
        if (this.scrollVelocity > this.velocityThreshold) {
          this.header.classList.add('header-premium--velocity-fast');
          this.header.classList.remove('header-premium--velocity-slow');
        } else {
          this.header.classList.add('header-premium--velocity-slow');
          this.header.classList.remove('header-premium--velocity-fast');
        }
        
        // 常に表示状態を維持（改良版）
        if (scrollTop > this.headerBounds.bottom) {
          this.smartReveal(scrollProgress);
        }
        
      } else {
        // トップ付近での処理
        if (this.hasScrolled) {
          this.hasScrolled = false;
          this.header.classList.remove('header-premium--scrolled');
        }
        
        if (scrollTop <= this.headerBounds.top) {
          this.premiumReset();
        }
      }
      
      // 背景ブラー効果の動的調整
      this.updateBackdropEffect(scrollProgress);
    }

    smartReveal(scrollProgress = 1) {
      // 既にstickyスタイルが適用されている場合はアニメーションしない
      if (this.header.classList.contains('shopify-section-header-sticky')) {
        return;
      }
      
      if (this.animationState === 'revealing') return;
      
      this.animationState = 'revealing';
      
      // RAF を使用してスムーズなアニメーション
      if (this.rafId) {
        cancelAnimationFrame(this.rafId);
      }
      
      this.rafId = requestAnimationFrame(() => {
        this.header.classList.add('shopify-section-header-sticky', 'header-premium--revealing');
        this.header.classList.remove('shopify-section-header-hidden');
        
        // アニメーション完了後の処理
        setTimeout(() => {
          this.header.classList.remove('header-premium--revealing');
          this.animationState = 'idle';
        }, 300);
      });
    }

    updateBackdropEffect(scrollProgress) {
      // スクロール進行度に応じた背景効果
      const blurAmount = scrollProgress * 20;
      const opacity = 0.85 + (scrollProgress * 0.15);
      
      this.header.style.setProperty('--backdrop-blur', `${blurAmount}px`);
      this.header.style.setProperty('--backdrop-opacity', opacity);
    }

    premiumReset() {
      if (this.animationState === 'resetting') return;
      
      this.animationState = 'resetting';
      
      if (this.rafId) {
        cancelAnimationFrame(this.rafId);
      }
      
      this.rafId = requestAnimationFrame(() => {
        this.header.classList.remove(
          'shopify-section-header-hidden', 
          'shopify-section-header-sticky', 
          'header-premium--revealing',
          'header-premium--velocity-fast',
          'header-premium--velocity-slow'
        );
        
        setTimeout(() => {
          this.animationState = 'idle';
        }, 300);
      });
    }

    hide() {
      return; // 常時表示のため無効化
    }

    reveal() {
      this.smartReveal();
    }

    reset() {
      this.premiumReset();
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => {
        if (disclosure.close) {
          disclosure.close();
        }
      });
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal && this.searchModal.close) {
        this.searchModal.close(false);
      }
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
